import { useEffect } from 'react';

export const useScrollToTop = () => {
  useEffect(() => {
    setTimeout(function () {
      window.scrollTo(0, 0);
      // console.log('Use scroll to top');
    }, 0);
  }, []);

  return null;
};
